/** Path helpers for /about page links. */

export function normalizeAboutPagePath(url) {
  const s = String(url || '').trim();
  if (!s) return '';
  if (/^(https?:|mailto:|tel:)/i.test(s)) return s;
  return s.startsWith('/') ? s : `/${s}`;
}

export function isExternalAboutPath(path) {
  return /^(https?:|mailto:|tel:)/i.test(String(path || '').trim());
}
